"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paymentMethodMap = exports.deliveryMethodsMap = exports.configurableProductMap = exports.UNMAPPED_PAYMENT_METHOD = exports.UNMAPPED_DELIVERY_METHOD = exports.SEARCH_RESULTS_PAGE = exports.PRODUCT_DETAILS_PAGE_ID = exports.GENERIC_VIEW_PAGE_EVENT_NAME = exports.ERROR_PAGE = exports.DTM_EVENTS_DOM_ELEMENT = exports.CHECKOUT_PAGE = exports.CATEGORY_PAGE = exports.BTS_CONFIGURABLE_SRP_TYPE = exports.BTS_CONFIGURABLE_SLS_TYPE = void 0;
var _configurableProductM;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DTM_EVENTS_DOM_ELEMENT = 'dtmEventsDomElement';
exports.DTM_EVENTS_DOM_ELEMENT = DTM_EVENTS_DOM_ELEMENT;
var PRODUCT_DETAILS_PAGE_ID = 'product-details-page';
exports.PRODUCT_DETAILS_PAGE_ID = PRODUCT_DETAILS_PAGE_ID;
var ERROR_PAGE = 'ErrorPage';
exports.ERROR_PAGE = ERROR_PAGE;
var CATEGORY_PAGE = 'Category';
exports.CATEGORY_PAGE = CATEGORY_PAGE;
var CHECKOUT_PAGE = 'Checkout';
exports.CHECKOUT_PAGE = CHECKOUT_PAGE;
var SEARCH_RESULTS_PAGE = 'Search';
exports.SEARCH_RESULTS_PAGE = SEARCH_RESULTS_PAGE;
var UNMAPPED_PAYMENT_METHOD = 'unmapped payment method';
exports.UNMAPPED_PAYMENT_METHOD = UNMAPPED_PAYMENT_METHOD;
var UNMAPPED_DELIVERY_METHOD = 'unmapped delivery method';
exports.UNMAPPED_DELIVERY_METHOD = UNMAPPED_DELIVERY_METHOD;
var GENERIC_VIEW_PAGE_EVENT_NAME = 'generic-page-view'; // There is a custom rule in DTM listening on this event

/*
mapping of CDC/FRA values to legacy analytics values

To save on time I have found the following legacy values for future supported payments:
https://bitbucket.officeworks.internal/projects/WS/repos/webshop/browse/WebSphereCommerceServerExtensionsLogic/src/com/ow/commerce/order/event/constants/ProcessOrderConstants.java#50-51,108,140
 */
exports.GENERIC_VIEW_PAGE_EVENT_NAME = GENERIC_VIEW_PAGE_EVENT_NAME;
var paymentMethodMap = {
  'Credit Card IPG': 'IPGPunchout',
  AfterPay: 'AfterpayPunchout',
  PayPal: 'PayPal',
  'Line of Credit': '30DayAccount',
  ZipPay: 'ZippayPunchout'
};

// mapping of CDC/FRA values to legacy analytics values
exports.paymentMethodMap = paymentMethodMap;
var deliveryMethodsMap = {
  DTD: 'deliver',
  CNC: 'collect'
};
exports.deliveryMethodsMap = deliveryMethodsMap;
var BTS_CONFIGURABLE_SLS_TYPE = 'SCHL010';
exports.BTS_CONFIGURABLE_SLS_TYPE = BTS_CONFIGURABLE_SLS_TYPE;
var BTS_CONFIGURABLE_SRP_TYPE = 'SCHL020';
exports.BTS_CONFIGURABLE_SRP_TYPE = BTS_CONFIGURABLE_SRP_TYPE;
var configurableProductMap = (_configurableProductM = {}, _defineProperty(_configurableProductM, BTS_CONFIGURABLE_SLS_TYPE, 'BTS'), _defineProperty(_configurableProductM, BTS_CONFIGURABLE_SRP_TYPE, 'BTS'), _configurableProductM);
exports.configurableProductMap = configurableProductMap;